import { StarIcon } from "@heroicons/react/solid";
import {
  LetterbookLibraryType,
  LetterlistTableColumnSettingType,
} from "features/Letterbooks/types";
import LetterbookCell from "../LetterbookCell";

export default function CurrentUserRating({
  letterbook,
}: {
  letterbook: LetterbookLibraryType;
}) {
  const { ownerUserBook } = letterbook.data;

  return (
    <LetterbookCell className="font-bold text-xl">
      <span className="flex items-center">
        <span>{ownerUserBook?.rating || "-"}</span>
        <StarIcon className="text-yellow-400 w-6 h-6 inline mr-1" />
      </span>
    </LetterbookCell>
  );
}

export const settings = {
  key: "CurrentUserRating",
  title: "Rating",
} as LetterlistTableColumnSettingType;
